import { Box, Typography, List, ListItem, ListItemText } from '@mui/material'
import { COLORS } from '../constants/colors'
import { TEXT } from '../constants/text'

export default function TermsPage() {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 900, mb: 3, color: COLORS.gold.primary }}>
        Terms of Service
      </Typography>

      <Typography sx={{ fontSize: '0.85rem', color: COLORS.text.secondary, lineHeight: 1.8, mb: 3 }}>
        By accessing or using {TEXT.BUSINESS.NAME}, you agree to be bound by these Terms of Service.
        Please read them carefully before using our platform.
      </Typography>

      <Section title="1. Service Description">
        {TEXT.BUSINESS.NAME} provides signal intelligence and analytics for Solana-based tokens.
        We do not provide financial advice, manage funds, or execute trades on your behalf.
        Our service is strictly non-custodial — we never have access to your private keys.
      </Section>

      <Section title="2. Eligibility">
        You must be at least 18 years of age and not a resident of any OFAC-sanctioned jurisdiction
        to use our service. By connecting your wallet, you confirm that you are not on any sanctions
        list and comply with all applicable laws.
      </Section>

      <Section title="3. No Financial Advice">
        Signals, rug scores, and analytics provided through {TEXT.BUSINESS.NAME} are for
        informational purposes only. They do not constitute financial advice, investment
        recommendations, or guarantees of any kind.
      </Section>

      <Section title="4. Subscription & Payments">
        Paid tiers (Pro, Elite) are billed monthly. Payments are non-refundable unless otherwise
        required by applicable law. We reserve the right to change pricing with 30 days' notice.
      </Section>

      <Section title="5. Limitation of Liability">
        {TEXT.BUSINESS.NAME} is provided "as-is" without warranties of any kind. We are not liable
        for trading losses, missed signals, system downtime, or any damages arising from the use
        of our platform.
      </Section>

      <Section title="6. Modifications">
        We may update these Terms at any time. Continued use of the service after changes
        constitutes acceptance of the revised Terms.
      </Section>
    </Box>
  )
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', mb: 0.5 }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: '0.85rem', color: COLORS.text.secondary, lineHeight: 1.8 }}>
        {children}
      </Typography>
    </Box>
  )
}
